import { render } from "./LottoTicketDetails.vue?vue&type=template&id=6e2c861c"
import script from "./LottoTicketDetails.vue?vue&type=script&lang=js"
export * from "./LottoTicketDetails.vue?vue&type=script&lang=js"

import exportComponent from "/home/jenkins/agent/workspace/UltimaMonitor_lgames/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__